export default {
  release: '17.2',
  date: 'July 2024',
  releasePostUrl: 'https://docs.gitlab.com/releases/17/gitlab-17-2-released/#this-months-notable-contributor-phawin-khongkhasawan',
  contributors: [
    {
      name: 'Phawin Khongkhasawan',
      gitlabUsername: 'lifez',
    },
  ],
  writeUp: `Phawin Khongkhasawan is a Tech Lead at [Jitta](https://www.jitta.com/) and started contributing
to GitLab in February of 2024.
In just a few months, Phawin has merged over 20 contributions and his contributions have also been
featured in [16.11](https://about.gitlab.com/releases/2024/04/18/gitlab-16-11-released/#test-project-hooks-with-the-rest-api),
[17.0](https://about.gitlab.com/releases/2024/05/16/gitlab-17-0-released/#customize-avatars-for-users),
and [17.1](https://about.gitlab.com/releases/2024/06/20/gitlab-17-1-released/#require-confirmation-for-manual-jobs).

Phawin was first nominated by [Magdalena Frankiewicz](https://gitlab.com/m_frankiewicz), Product Manager at GitLab,
for improving Webhook related features like the request to [Allow triggering of project test webhooks via the API](https://gitlab.com/gitlab-org/gitlab/-/issues/455589).
GitLab engineers [Marc Shaw](https://gitlab.com/marc_shaw) and [Jose Ivan Vargas](https://gitlab.com/jivanvl),
and GitLab Product Manager [Rutvik Shah](https://gitlab.com/rutshah), highlighted Phawin's patience
in collaboration and iteration, two of [GitLab's core values](https://handbook.gitlab.com/handbook/values/).

"I really appreciate Phawin's work, patience and perseverance on pushing the feature to [Add order by merged_at](https://gitlab.com/gitlab-org/gitlab/-/merge_requests/147052)
to the finish line," says [Patrick Bajao](https://gitlab.com/patrickbajao), Staff Backend Engineer at GitLab.
"It took a couple of milestones before it got merged and deployed, but he didn't stop and he continued
to collaborate with us."

A big thank you to Phawin for showing how new contributors can make an immediate impact and help
co-create GitLab.`,
};
